export const validateHex = (value: string): boolean => {
  if (!value || typeof value !== "string") {
    return false;
  }
  const hexRegExp = /^([0-9A-F]{3}){1,2}$/i;
  return hexRegExp.test(value.replace(/#/g, ""));
};
